export interface INcsAudit {
    centerName: string,
    chainNumber: number,
    drAlias: string,
    txpDate: string,
    patientAbo: string,
    type: string,
    ncsAdjust: number,
    ncsAdjustFV: number
}